module.exports = __webpack_public_path__ + "img/activity-monitor-trial-expired.0c601f4a.webp";